import { GoogleMap, Marker } from '@react-google-maps/api';
import DwFormField from '@ui/formfield/DwFormField';
import RadioGroup from '@ui/radioGroup/RadioGroup';
import RadioGroupItem from '@ui/radioGroup/RadioGroupItem';
import api from '@utils/api';
import { BAA } from '@utils/constants';
import maputils from '@utils/maputils';
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import BookAnAppointmentStore from './BookAnAppointmentStore';
import { addURLParameter } from '@common/utils/urlutils';
const BookAnAppointmentStoreSelector = (props) => {
    const { t } = useTranslation();
    const [countrySelect, setCountrySelect] = useState();
    const [citySelect, setCitySelect] = useState();
    const [storesByCity, setStoresByCity] = useState([]);
    const [mapZoom, setMapZoom] = useState(10);
    const [mapCenter, setMapCenter] = useState();
    const [stores, setStores] = useState([]);
    const [storeFilter, setStoreFilter] = useState([]);
    const [storesSlotType, setStoresSlotType] = useState([]);
    const [countries, setCountries] = useState([]);
    const [loadingCities, setLoadingCities] = useState(true);
    const mapEl = useRef();
    const cities = useMemo(() => {
        const storesFilterArray = stores.filter((store) => storeFilter.includes(store.ID));
        return [...new Set(storesFilterArray.map((store) => store.city))];
    }, [stores, storeFilter]);
    const filterStore = () => {
        return stores.filter((store) => storeFilter.includes(store.ID));
    };
    useEffect(() => {
        props.resetFields;
    }, [props.resetFields]);
    useEffect(() => {
        let personalizationReason = Number(props.initialValues.reason) == BAA.REASONS.PERSONALIZATION;
        updateCountries(personalizationReason);
        // if (!personalizationReason) {
        //   onSelectReason(props.initialValues.reason);
        // }
    }, []);
    useEffect(() => {
        if (!props.liveBoutique && props.store) {
            setMapCenter(new google.maps.LatLng(props.store.latitude, props.store.longitude));
            setMapZoom(18);
        }
    }, [props.store]);
    useEffect(() => {
        if (stores.length > 0 && citySelect) {
            let storeFiltered = filterStore();
            setStoresByCity(storeFiltered.filter((store) => {
                return store.city === citySelect;
            }));
            // on city change
            selectStore(stores.filter((filteredStore) => filteredStore.city === citySelect && (storeFilter === null || storeFilter === void 0 ? void 0 : storeFilter.includes(filteredStore === null || filteredStore === void 0 ? void 0 : filteredStore.ID)))[0]);
            props.mutator({ storeid: stores.filter((store) => store.city === citySelect)[0] });
        }
    }, [citySelect, stores, storeFilter]);
    const countrySelectLabel = useMemo(() => {
        if ((countries === null || countries === void 0 ? void 0 : countries.length) && countrySelect) {
            const country = countries.find((el) => el.value === countrySelect);
            return country.localizedLabel;
        }
        return window.localizedCountryname;
    }, [countries, countrySelect]);
    const storeFilterArray = (country, personalizationReason, reasonSelect) => {
        api.bookAnAppointmentStores(country, personalizationReason ? '861860000' : '', props.appointmentType, reasonSelect).then((data) => {
            let arr = [...storeFilter];
            if (data.stores) {
                arr = data.stores.map((e) => e.code);
                setStoresSlotType(data.stores);
            }
            setStoreFilter(arr);
        });
        return storeFilter;
    };
    const updateStores = async (country, personalizationReason) => {
        setLoadingCities(true);
        // debugger;
        if (props.liveBoutique) {
            api.getLiveBoutiqueStoresForAppointment(country).then((data) => {
                // debugger;
                var _a;
                setStores(data.Store);
                setLoadingCities(false);
                if (props.initialValues.citySelect) {
                    const initialCity = (_a = stores.find((el) => el.city == props.initialValues.citySelect)) === null || _a === void 0 ? void 0 : _a.city;
                    if (initialCity)
                        setCitySelect(initialCity);
                }
            });
        }
        else {
            api.getStoresForAppointment(country).then((data) => {
                // debugger;
                var _a;
                setStores(data.Store);
                setLoadingCities(false);
                if (props.initialValues.citySelect) {
                    const initialCity = (_a = stores.find((el) => el.city == props.initialValues.citySelect)) === null || _a === void 0 ? void 0 : _a.city;
                    if (initialCity)
                        setCitySelect(initialCity);
                }
            });
        }
    };
    const updateCountries = async (personalizationReason, reasonValue) => {
        api.getCountriesWithBAA(personalizationReason).then((data) => {
            setCountries(data);
            let selectedCountry = data.find((el) => el.selected);
            if (props.initialValues.countrySelect) {
                selectedCountry = data.find((el) => el.value == props.initialValues.countrySelect);
            }
            if (selectedCountry) {
                setCountrySelect(selectedCountry.value);
                props.mutator({ countrySelect: selectedCountry.value });
                storeFilterArray(countrySelect, personalizationReason, reasonValue);
                updateStores(selectedCountry.value, personalizationReason);
            }
            else {
                // mostro il messaggio che non ci sono store con BAA per la country corrente
            }
        });
    };
    const selectStore = (store) => {
        var _a;
        let availableSlotsTypes;
        let availableSlotTypes;
        if (store) {
            let storeSlotType = storesSlotType === null || storesSlotType === void 0 ? void 0 : storesSlotType.filter((e) => (e === null || e === void 0 ? void 0 : e.code) == store.ID);
            availableSlotsTypes = (_a = storeSlotType[0]) === null || _a === void 0 ? void 0 : _a.availableSlotTypes;
            if ((availableSlotsTypes === null || availableSlotsTypes === void 0 ? void 0 : availableSlotsTypes.length) > 1 && (availableSlotsTypes === null || availableSlotsTypes === void 0 ? void 0 : availableSlotsTypes.includes(BAA.APPOINTMENT.CARAVAN))) {
                availableSlotTypes = BAA.APPOINTMENT.CARAVAN;
            }
            else {
                availableSlotTypes = availableSlotsTypes[0];
            }
        }
        props.setAvailableSlotTypes && props.setAvailableSlotTypes(availableSlotTypes);
        props.onSelect && props.onSelect(store);
    };
    const onSelectCity = (city) => {
        setCitySelect(city);
        selectStore(null);
    };
    const pickupStores = (virtualAppointment) => {
        return virtualAppointment ? (React.createElement(React.Fragment, null,
            React.createElement(DwFormField, { requiredLabel: true, def: props.formdef, disabled: loadingCities, name: "storeid", type: "select", onChange: (e) => {
                    const store = storesByCity.find((store) => {
                        return store.ID == e.target.value;
                    });
                    selectStore(store);
                }, options: [
                    ...[
                        {
                            value: '',
                            selected: false,
                            label: t('bookanappointment.selectstore.placeholder'),
                        },
                    ],
                    ...storesByCity.map((store, i) => {
                        var _a;
                        return {
                            value: store.ID,
                            selected: store.ID === ((_a = props.store) === null || _a === void 0 ? void 0 : _a.ID),
                            label: store.name,
                        };
                    }),
                ] }))) : (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "baa-storelist" },
                React.createElement(RadioGroup, { id: "storelist", setSelected: (id) => {
                        const store = storesByCity.find((store) => {
                            return store.ID == id;
                        });
                        selectStore(store);
                    } }, storesByCity.map((store, index) => {
                    var _a;
                    return (React.createElement(RadioGroupItem, { inputCentered: virtualAppointment, content: React.createElement(BookAnAppointmentStore, { store: store, index: index }), key: store.ID, id: store.ID, selected: store.ID === ((_a = props.store) === null || _a === void 0 ? void 0 : _a.ID) }));
                })))));
    };
    const noStoresMessage = useCallback(() => {
        return (countries === null || countries === void 0 ? void 0 : countries.length) > 0 && !countries.find((el) => el.selected) ? (React.createElement("div", { className: "row mb-24" },
            React.createElement("div", { className: "col-12" },
                React.createElement("p", null, t('bookanappointment.nostoresincurrentlocation', { country: window.countryname }))))) : (React.createElement(React.Fragment, null));
    }, [countries]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "row" },
            React.createElement("div", { className: "col-24 col-lg-12" },
                React.createElement("p", null,
                    t('bookanappointment.location.message', { country: countrySelectLabel }),
                    " "),
                React.createElement("a", { href: addURLParameter(window.location.href, 'countryselector', 'true') }, t('bookanappointment.location.link')))),
        React.createElement("div", { className: "checkout-pickup bookanappointment-wrapper" },
            noStoresMessage(),
            !props.showmap ? (React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col-24 col-lg-12" },
                    React.createElement(DwFormField, { requiredLabel: true, def: props.formdef, disabled: loadingCities, name: "citySelect", type: "select", onChange: (e) => onSelectCity(e.target.value), options: [
                            ...[
                                {
                                    value: '',
                                    selected: false,
                                    label: t('checkout.picking.selectcity'),
                                },
                            ],
                            ...cities.map((city, i) => {
                                return {
                                    value: city,
                                    selected: city === citySelect,
                                    label: city,
                                };
                            }),
                        ] })),
                React.createElement("div", { className: "col-24 col-lg-12 overflow-visible" },
                    stores.length > 0 && citySelect && props.liveBoutique && (React.createElement("div", { className: "row" },
                        React.createElement("p", { className: "disclaimer mt-20 mb-32" }, t('liveboutique.disclaimer')))),
                    !props.resetFields && pickupStores(true)))) : (React.createElement("div", { className: "row row-gap-40" },
                React.createElement("div", { className: "col-24 col-lg-10" },
                    React.createElement(DwFormField, { requiredLabel: true, def: props.formdef, disabled: loadingCities, name: "citySelect", type: "select", onChange: (e) => onSelectCity(e.target.value), options: [
                            ...[
                                {
                                    value: '',
                                    selected: false,
                                    label: t('checkout.picking.selectcity'),
                                },
                            ],
                            ...cities.map((city, i) => {
                                return {
                                    value: city,
                                    selected: city === citySelect,
                                    label: city,
                                };
                            }),
                        ] }),
                    (stores === null || stores === void 0 ? void 0 : stores.length) > 0 && citySelect && !props.resetFields && pickupStores(props.appointmentType == BAA.APPOINTMENT.VIRTUAL)),
                React.createElement("div", { className: "col-24 col-lg-12 offset-lg-2" }, (stores === null || stores === void 0 ? void 0 : stores.length) > 0 && citySelect && (React.createElement("div", { className: "checkout-pickup__map" },
                    React.createElement(GoogleMap, { mapContainerStyle: {
                            width: '100%',
                            height: '100%',
                        }, center: mapCenter, zoom: mapZoom, onLoad: (map) => {
                            mapEl.current = map;
                        }, options: {
                            streetViewControl: false,
                            mapTypeControl: false,
                            maxZoom: 14,
                            styles: maputils.style['ST'],
                        } },
                        React.createElement(React.Fragment, null, stores.map((store, i) => {
                            var _a;
                            return (React.createElement(Marker, { key: i, position: { lat: store.latitude, lng: store.longitude }, icon: ((_a = props.store) === null || _a === void 0 ? void 0 : _a.ID) === store.ID ? (props.mapmarker || '').replace('.svg', '-selected.svg') : props.mapmarker }));
                        })))))))))));
};
export default BookAnAppointmentStoreSelector;
